/**
 * Mock, no-op version of the EventStorageClient. To be used in the Athena's
 * specimen.
 */
export class MockEventStorageClient {
    eventStorageOrigin = "MockEventStorageOrigin";
    async saveAthenaEvents(athenaEvents, _options) {
        return athenaEvents.map((athenaEvent) => ({
            athenaEvent: athenaEvent,
            succeeded: true,
            error: null,
        }));
    }
    async fetchAthenaEvents(_filters) {
        return [];
    }
}
//# sourceMappingURL=MockEventStorageClient.js.map